export default __webpack_public_path__ + "static/media/zebra.7bac4270.gif";